import { encode as base64_encode } from 'base-64';
import { postApi } from '../components/Utility'
import {
  action,
  makeObservable,
  observable,
} from 'mobx';


class VehicleLiveLocationStore {
  vehicleLiveLocationVehicles = []
  total = 0
  loading = false
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
      vehicleLiveLocationVehicles: observable,
      loading: observable,
      total: observable,
      loadData: action,
      getLiveLocationData: action,
      addData: action,
      deleteRecord: action,
      getVehicleId: action
    });
    this.rootStore = rootStore;

  }



  async loadData({ companyId, offset, searchField, limit, page }) {
    this.loading = true
    var postData = { "companyId": companyId, "searchField": searchField, "offset": offset, "limit": limit, "page": page }

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=liveLocation&a=getLiveLocation", "postData=" + base64Input);

    this.vehicleLiveLocationVehicles = response?.data?.data?.liveLocation
    this.total = parseInt(response?.data?.data.TotalCount)
    this.loading = false
  }

  async addData(liveLocationData) {
    var postData = liveLocationData
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=liveLocation&a=update", "postData=" + base64Input);
    return response

  }

  async getLiveLocationData(id) {
    var postData = { "id": id, offset: 0, limit: 1 }
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=liveLocation&a=getLiveLocation", "postData=" + base64Input);
    return response.data.data.liveLocation[0]
  }

  async deleteRecord({ id }) {
    var postData = { "id": id }
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=liveLocation&a=delete", "postData=" + base64Input);
    return response;

  }

  //Use livelocation url

  async getVehicleId(vehicleId) {
    var postData = { vehicleId: vehicleId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=liveLocation&a=getVehicleId",
        "postData=" + base64Input
      );
    return response?.data?.data;
  }


}

export default VehicleLiveLocationStore;
